/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RatingsInputs */

const cs_nav_ratings = /** @type {(inputs: Nav_RatingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení`)
};

const sk_nav_ratings = /** @type {(inputs: Nav_RatingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnotenie`)
};

const en_nav_ratings = /** @type {(inputs: Nav_RatingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratings`)
};

/**
* | output |
* | --- |
* | "Ratings" |
*
* @param {Nav_RatingsInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_ratings = /** @type {((inputs?: Nav_RatingsInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RatingsInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_ratings(inputs)
	if (locale === "sk") return sk_nav_ratings(inputs)
	return en_nav_ratings(inputs)
});